<div id="managePopUp cusmodal">
  <div class="modal-header">
    <div class="modal-title">{{suspendHeader}}</div>
    <button type="button" class="close" aria-label="Close" (click)="closeSuspendModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="isSingleFlow">
      <div *ngFor="let line of suspendendeLines">
        <div class="modal-subtitle">
          <span id="old-number" class="selected-number">{{line?.msisdn}}</span>
        </div>
        <p class="about-suspend">
          {{authoringContentData?.manageLine?.selectSuspendReason}}
        </p>
        <div class="row mb-4">
          <div class="col-12 col-sm-6 col-md-6 mt-3">
            <div class="custom-ddl-wrapper">
                <mat-form-field class="w100">
                  <mat-label>{{authoringContentData?.manageLine?.reasonForChange}}</mat-label>
                  <mat-select>
                      <mat-option *ngFor="let reason of reasons" [value]="reason.description" (click)="lineApproverType = '';approverType = '';selectReason(reason)">
                          {{reason.description}}
                      </mat-option>
                  </mat-select>
              </mat-form-field>
            </div>
            <div *ngIf = "resonErrorInline" class = "displayErrorInline">
                {{resonErrorInline}}
            </div>
          </div>

          <div class="col-12 col-sm-6 col-md-6 mt-3" *ngIf="reasonForChanges && approverType ">
            <div *ngIf="reasonForChanges?.code !== ssqConstant">
              <div class="custom-ddl-wrapper">
                  <mat-form-field class="w100">
                    <mat-label>{{authoringContentData?.suspend?.approverType}}</mat-label>
                    <mat-select [formControl]="lineApproverType">
                        <mat-option
                        *ngFor="let aproverType of approverTypeList"
                        [value]="aproverType.description" (click)="startDate='';endDate = '';selectsubmitCheckBox = false;tncCheckBox = true;changeApproverType(reasonForChanges.code, aproverType)">
                            {{aproverType.description}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
              </div>
              <div *ngIf = "aproverErrorInline" class = "displayErrorInline">
                  {{aproverErrorInline}}
              </div>
            </div>
          </div>
        </div>


        <div class="row" *ngIf="reasonForChanges && approverType ">
          <div class="col-sm-6 col-lg-6 col-md-6 no-padding mt-3">
           <div class="label_box pr9">
              <div class="date_label ">
                <div class="datepic_box">
                  <input tabindex="0" role="button" type="text" readonly="readonly" class="datepicker" name="dp" [(ngModel)]="startDate" ngbDatepicker #d1="ngbDatepicker"
                  (keydown)="d1.toggle()" (click)="d1.toggle()" [disabled]="!approverType" [minDate]="minimumDate" [maxDate] = "maxStartDate" (dateSelect)="oneLineStartDateSelected(reasonForChanges.code, approverType)" (ngModelChange)="endDate = '';selectsubmitCheckBox = false;tncCheckBox = true;" />
                  <label id="temporary-start_date_label start-date-position" [ngClass]="{'floating-label-hasvalue-date': startDate}">{{authoringContentData?.manageLine?.startDate}}*</label>
                  <span class="box_icon date_iocn" (click)="d1.toggle()"></span>
                  <span class="far fa-calendar-alt " ></span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-lg-6 col-md-6 no-padding mt-3 zindex1" id="temporary-end_date_div">
            <div class="label_box pr1">
              <div class="date_label ">
                <div class="datepic_box">
                 <input  tabindex="0" role="button" type="text" readonly="readonly" class="datepicker" name="dp" [(ngModel)]="endDate" ngbDatepicker #d="ngbDatepicker"
                 (keydown)="d.toggle()" (click)="d.toggle()" [disabled]="!startDate" (dateSelect)="oneLineEndDateSelected()" [ngClass]="{'endDateClaenderDisable': !startDate}"
                    [minDate]="minimumEndDate" [maxDate]="maxDate"  />
                  <label *ngIf = "reasonForChanges?.code !== suncConstant" id="temporary-end_date_label start-date-position" [ngClass]="{'floating-label-hasvalue-date': endDate}">{{authoringContentData?.manageLine?.endDate}}*</label>
                  <label *ngIf = "reasonForChanges?.code === suncConstant" id="temporary-end_date_label start-date-position" [ngClass]="{'floating-label-hasvalue-date': endDate}">{{authoringContentData?.manageLine?.endDate}} (Optional)</label>
                  <span class="box_icon date_iocn" (click)="d.toggle()"></span>
                  <span class="far fa-calendar-alt " ></span> </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4 text-color" *ngIf="reasonForChanges?.code === elstConstant">{{authoringContentData?.manageLine?.lostStolenInfoTxt}}</div>
      <div class="mt-4 text-color" *ngIf="reasonForChanges?.code === ssqConstant">{{authoringContentData?.manageLine?.seasonalSuspInfoTxt}}</div>
      <div class="mt-4 text-color" *ngIf="reasonForChanges?.code === tmpsConstant">{{authoringContentData?.manageLine?.temporarySuspInfoTxt}}</div>
      <div class="mt-4 text-color" *ngIf="reasonForChanges?.code === edusConstant">{{authoringContentData?.manageLine?.educationSuspInfoTxt}}</div>
      <div class="mt-4 text-color" *ngIf="reasonForChanges?.code === imsConstant">{{authoringContentData?.manageLine?.imsInfoTxt}}</div>
      <div class="mt-4 text-color" *ngIf="reasonForChanges?.code === mimsConstant">{{authoringContentData?.manageLine?.mimsInfoTxt}}</div>
      <div class="mt-4 text-color" *ngIf="reasonForChanges?.code === suncConstant">{{authoringContentData?.manageLine?.suncInfoTxt}}</div>
      <div class="mt-4 text-color" *ngIf="reasonForChanges?.code === retnConstant">{{authoringContentData?.manageLine?.retnInfoTxt}}</div>

      <div class = "displayErrorInline" *ngIf = "susEligibilityerroeInline">
          {{susEligibilityerroeInline}}
      </div>
    </div>
    <!-- start accordian-->
    <div *ngIf="!isSingleFlow">
      <p class="about-suspend">
        {{authoringContentData?.manageLine?.selectSuspendDate}}
      </p>
      <div class="row">
        <div class="col-12 col-sm-6 col-md-6">
          <div class="row">
            <div class="col-12">
              <div class="custom-ddl-wrapper nopadding-left">
                <mat-form-field class="w100">
                  <mat-label>{{authoringContentData?.manageLine?.reasonForChange}}</mat-label>
                  <mat-select>
                      <mat-option *ngFor="let reason of reasons" [value]="reason.description" (click)="lineApproverType = ''; approverType = '';selectReason(reason)">
                          {{reason.description}}
                      </mat-option>
                  </mat-select>
              </mat-form-field>


              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-6">
          <div class="mt-3">
            <mat-checkbox [(ngModel)]="applyToAll" [disabled]="disableApplyToAll" (change)="applyToAllCheckBox()"
              [ngClass]="{'checkBoxDisabled': (disableApplyToAll)}"></mat-checkbox>
            <span class="text-color margin-left-checkBox pr-top">{{authoringContentData?.manageLine?.applyToAll}}</span>
          </div>
        </div>
      </div>

      <div class="mt-4 text-color" *ngIf="reasonForChanges?.code === elstConstant">{{authoringContentData?.manageLine?.lostStolenInfoTxt}}</div>
      <div class="mt-4 text-color" *ngIf="reasonForChanges?.code === ssqConstant">{{authoringContentData?.manageLine?.seasonalSuspInfoTxt}}</div>
      <div class="mt-4 text-color" *ngIf="reasonForChanges?.code === tmpsConstant">{{authoringContentData?.manageLine?.temporarySuspInfoTxt}}</div>
      <div class="mt-4 text-color" *ngIf="reasonForChanges?.code === edusConstant">{{authoringContentData?.manageLine?.educationSuspInfoTxt}}</div>
      <div class="mt-4 text-color" *ngIf="reasonForChanges?.code === imsConstant">{{authoringContentData?.manageLine?.imsInfoTxt}}</div>
      <div class="mt-4 text-color" *ngIf="reasonForChanges?.code === mimsConstant">{{authoringContentData?.manageLine?.mimsInfoTxt}}</div>
      <div class="mt-4 text-color" *ngIf="reasonForChanges?.code === suncConstant">{{authoringContentData?.manageLine?.suncInfoTxt}}</div>
      <div class="mt-4 text-color" *ngIf="reasonForChanges?.code === retnConstant">{{authoringContentData?.manageLine?.retnInfoTxt}}</div>

      <div class="row">
        <div class="col-12 col-sm-6 col-md-6 mt-3" *ngIf="reasonForChanges && approverType">
          <div *ngIf="reasonForChanges?.code !== ssqConstant">
          <div class="row">
              <div class="col-12">
                <div class="custom-ddl-wrapper nopadding-left">
                  <mat-form-field class="w100">
                    <mat-select placeholder="{{authoringContentData?.suspend?.approverType}}" [formControl]="lineApproverType">
                        <mat-option *ngFor="let aproverType of approverTypeList" [value]="aproverType.description" (click)="startDate = ''; endDate = ''; changeApproverType(reasonForChanges.code, aproverType)">
                            {{aproverType.description}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row position-r" *ngIf="reasonForChanges && approverType">
        <div class="col-sm-6 col-lg-6 col-md-6 no-padding mt-3 zindex5">
         <div class="label_box pr9">
            <div class="date_label">
              <div class="datepic_box">
                <input type="text" readonly="readonly" class="datepicker" name="dp" [(ngModel)]="startDate" ngbDatepicker #d1="ngbDatepicker"
                  (click)="d1.toggle()" [minDate]="minimumDate" [maxDate] = "maxStartDate" (dateSelect)="endDate = ''; oneLineStartDateSelected(reasonForChanges.code, approverType)"  />
                <label id="temporary-start_date_label start-date-position" [ngClass]="{'floating-label-hasvalue-date': startDate}">{{authoringContentData?.manageLine?.startDate}}*</label>
                <span class="box_icon date_iocn" (click)="d1.toggle()"></span>
                <span class="far fa-calendar-alt " ></span>
              </div>
            </div>
          </div>
          </div>
        <div class="col-sm-6 col-lg-6 col-md-6 no-padding mt-3 zindex1" id="temporary-end_date_div">
          <div class="label_box pr1">
            <div class="date_label">
              <div class="datepic_box">
               <input type="text" readonly="readonly" class="datepicker" name="dp" [(ngModel)]="endDate" ngbDatepicker #d="ngbDatepicker"
                  (click)="d.toggle()" [disabled]="!startDate" [ngClass]="{'endDateClaenderDisable': !startDate}"
                  [minDate]="minimumEndDate" [maxDate]="maxDate" (dateSelect)="disableApplyToAll = false;" />
                <label *ngIf = "reasonForChanges?.code !== suncConstant" id="temporary-end_date_label start-date-position" [ngClass]="{'floating-label-hasvalue-date': endDate}">{{authoringContentData?.manageLine?.endDate}}*</label>
                <label *ngIf = "reasonForChanges?.code === suncConstant" id="temporary-end_date_label start-date-position" [ngClass]="{'floating-label-hasvalue-date': endDate}">{{authoringContentData?.manageLine?.endDate}} (Optional)</label>
                <span class="box_icon date_iocn" (click)="d.toggle()"></span>
                <span class="far fa-calendar-alt "></span></div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 col-sm-6 col-md-6 tmo-numberOfLines">
          <span class="line-selected">
            {{suspendendeLines.length}} {{authoringContentData?.manageLine?.linesSelected}}
          </span>
        </div>
      </div>
      <br>
      <mat-accordion *ngFor="let line of suspendendeLines;let i = index">
        <mat-expansion-panel [expanded]="line.expendFlagValue" (closed)="expansionPanelClosed(line)" (opened)="expansionPanelOpened(line)">
          <mat-expansion-panel-header class="specific-class" (click)="setStep(i)">
            <mat-panel-title class="accordion-txt">
              <span class="succes_validator" *ngIf="line.succesValidator"></span>
              <span class="suspend_error_complete" *ngIf="line.errorValidator"></span>
              {{line?.msisdn}}
              <div id="displaytemporary_2" class="displaytemporary pl-5 col-md-7 col-sm-7 col-xs-7" *ngIf="(line.succesValidator || line.errorValidator) && line.msgShowOnPanel">
                <div class="row">
                  <div id="suspend-updateTemporary_2" class="suspend-update-temporary col-6 col-md-6 col-sm-6 col-xs-6"
                    aria-hidden="true">{{line.reasonForChangesMsgOnPanel.description}}</div>
                  <div id="displaydatetemporary_2" class="displaydatetemporary col-6 pl-3 col-md-6 col-sm-5 col-xs-6">{{line.startDateForamted
                    | date}}
                  </div>
                </div>
                <div class="row">
                  <div class="reasontemporarytxt col-6 col-md-6 col-sm-6 col-xs-6">{{authoringContentData?.manageLine?.reasonForChange}}</div>
                  <div class="reasontemporarytxt pl-3 col-6 col-md-6 col-sm-5 col-xs-6" style="text-transform:uppercase;">{{authoringContentData?.manageLine?.startDate}}</div>
                </div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="small-normal-black">
            <div class="row">
              <div class="col-12 col-sm-6 col-md-6">
                <div class="row">
                  <div class="col-12">
                    <div class="custom-ddl-wrapper nopadding-left">
                      <mat-form-field class="w100">
                        <mat-select placeholder="{{authoringContentData?.manageLine?.reasonForChange}}" [formControl]="line.reasonForChange">
                            <mat-option *ngFor="let reason of reasons" [value]="reason.description" (click)="line.lineApproverType = ''; line.startDate = ''; line.endDate = '';line.succesValidator = false;selectsubmitCheckBox = false;tncCheckBox = true; onChangeReasonForMultiple(line, reason)">
                                {{reason.description}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                      <div *ngIf = "line.resonErrorInline" class = "displayErrorInline">
                          {{line.resonErrorInline}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6" *ngIf="line.reasonForChanges && line.approverType">
                <div *ngIf="line.reasonForChanges?.code !== ssqConstant">
                  <div class="row">
                    <div class="col-12">
                      <div class="custom-ddl-wrapper nopadding-left">
                        <mat-form-field class="w100">
                          <mat-select placeholder="{{authoringContentData?.suspend?.approverType}}" [formControl]="line.lineApproverType" >
                              <mat-option *ngFor="let aproverType of line.approverTypeList" [value]="aproverType.description" (click)="line.startDate = ''; line.endDate = '';line.succesValidator = false;selectsubmitCheckBox = false;tncCheckBox = true; changeApproverTypeForMultiple(line, aproverType)">
                                  {{aproverType.description}}
                              </mat-option>
                          </mat-select>
                      </mat-form-field>

                      </div>
                      <div *ngIf = "line.aproverErrorInline" class = "displayErrorInline">
                          {{line.aproverErrorInline}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="line.reasonForChanges && line.approverType">
              <div class="col-12 col-sm-6 col-md-6 mt-3">
                <div class="label_box pr9">
                  <div class="date_label">
                    <div class="datepic_box">
                      <input type="text" readonly="readonly" class="datepicker" name="dp" [(ngModel)]="line.startDate" ngbDatepicker #d1="ngbDatepicker"
                        (click)="d1.toggle()" [minDate]="minimumDate" [maxDate] = "line.maxStartDate" (ngModelChange)="line.endDate = '';line.succesValidator = false;selectsubmitCheckBox = false;tncCheckBox = true;"
                        (dateSelect)="multipleStartDate(line)"/>

                      <label id="temporary-start_date_label start-date-position" [ngClass]="{'floating-label-hasvalue-date': line.startDate}">{{authoringContentData?.manageLine?.startDate}}*</label>
                      <span class="box_icon date_iocn" (click)="d1.toggle()"></span>
                      <span class="far fa-calendar-alt " ></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 mt-3" id="temporary-end_date_div">
                <div class="label_box pr1">
                  <div class="date_label">
                    <div class="datepic_box ">
                    <input type="text" readonly="readonly" class="datepicker" name="dp" [(ngModel)]="line.endDate" ngbDatepicker #d="ngbDatepicker"
                        (click)="d.toggle()" [disabled]="!line.startDate" (dateSelect)="multipleEndDateSelected(line)"
                        [ngClass]="{'endDateClaenderDisable': !line.startDate}" [minDate]="line.endMinDate" [maxDate]="line.maxDate"/>
                      <label *ngIf="line.reasonForChanges.code !== suncConstant" id="temporary-end_date_label start-date-position" [ngClass]="{'floating-label-hasvalue-date': line.endDate}">{{authoringContentData?.manageLine?.endDate}}*</label>
                      <label *ngIf="line.reasonForChanges.code === suncConstant" id="temporary-end_date_label start-date-position" [ngClass]="{'floating-label-hasvalue-date': line.endDate}">{{authoringContentData?.manageLine?.endDate}} (Optional)</label>
                      <span class="box_icon date_iocn" (click)="d.toggle()" [ngClass]="{'endDateClaenderDisable': !line.startDate}"></span>
                      <span class="far fa-calendar-alt " ></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf = "line.susEligibilityerroeInline" class = "displayErrorInline">
              <span>{{line.susEligibilityerroeInline}}</span>
            </div>

            <div class="mt-4 text-color" *ngIf="!applyToAll && line.reasonForChanges?.code === elstConstant">{{authoringContentData?.manageLine?.lostStolenInfoTxt}}</div>
            <div class="mt-4 text-color" *ngIf="!applyToAll && line.reasonForChanges?.code === ssqConstant">{{authoringContentData?.manageLine?.seasonalSuspInfoTxt}}</div>
            <div class="mt-4 text-color" *ngIf="!applyToAll && line.reasonForChanges?.code === tmpsConstant">{{authoringContentData?.manageLine?.temporarySuspInfoTxt}}</div>
            <div class="mt-4 text-color" *ngIf="!applyToAll && line.reasonForChanges?.code === edusConstant">{{authoringContentData?.manageLine?.educationSuspInfoTxt}}</div>
            <div class="mt-4 text-color" *ngIf="!applyToAll && line.reasonForChanges?.code === imsConstant">{{authoringContentData?.manageLine?.imsInfoTxt}}</div>
            <div class="mt-4 text-color" *ngIf="!applyToAll && line.reasonForChanges?.code === mimsConstant">{{authoringContentData?.manageLine?.mimsInfoTxt}}</div>
            <div class="mt-4 text-color" *ngIf="!applyToAll && line.reasonForChanges?.code === suncConstant">{{authoringContentData?.manageLine?.suncInfoTxt}}</div>
            <div class="mt-4 text-color" *ngIf="!applyToAll && line.reasonForChanges?.code === retnConstant">{{authoringContentData?.manageLine?.retnInfoTxt}}</div>

            <div class="row align-items-center h-100 mt-4">
              <div class="col-12 col-md-4 mb-2">
                <button type="button" class="col-12 primary_btn" (click)="nextStep(line)" [disabled]="!line.succesValidator">{{authoringContentData?.manageLine?.next}}
                </button>
              </div>
              <div class="col-12 col-md-4 mb-2">
                <a href="javascript:void(0)" (click)="removeNumber(line)" class="small-pink">{{authoringContentData?.manageLine?.removeNumber}} </a>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
        <hr id="tmo-suspendMulti-horizontalLine_1" class="suspend-horizontalline">
      </mat-accordion>
    </div>
    <!-- end accordian-->
  </div>
  <div class="modal-footer mt-2">
    <div class="row align-items-center h-100" >
      <div class="col-12 col-sm-12 col-md-4 col-lg-4">
        <!-- Button-->
        <button type="button" class="col-12 primary_btn" (click)="submitButtonClicked()" [disabled]="!selectsubmitCheckBox || disableSubmit_ForCareUser">{{authoringContentData?.manageLine?.submitChange}}</button>
      </div>
        <!-- term and condition-->
      <div *ngIf="!tncCheckBox" class="col-12 col-sm-12 col-md-8 col-lg-8 acceptance-bx align-items-center h-100">
        <span>
          <mat-checkbox [(ngModel)]="selectsubmitCheckBox" class="move-b-3" (click)="getUniqueReasonsSelected()"></mat-checkbox>
        </span>
        <span class="ml-3 text-color">{{authoringContentData?.manageLine?.agreeTerms}}</span>
      </div>
    </div>
    <!-- extra detail -->
    <div class="clr"></div>
    <div>
      <div  *ngIf="selectsubmitCheckBox">
        <div  *ngFor="let reason of uniqueReasonsSelected; let i = index">
          <div class="text-color" *ngIf="!isSingleFlow">For {{reason.description}}:</div>
          <div class="service-note" *ngIf="reason.code === tmpsConstant">
            <p class="text-color">{{authoringContentData?.manageLine?.selectTMPSReasonNoteTop}}</p>
            <p class="text-color">{{authoringContentData?.manageLine?.serviceSuspendNoteFirst}}</p>
            <p class="text-color">{{authoringContentData?.manageLine?.serviceNoteSecond}}</p>
          </div>
          <div class="service-note" *ngIf="reason.code === ssqConstant">
            <p class="text-color">{{authoringContentData?.manageLine?.serviceSSQNote}}</p>
            <p class="text-color">{{authoringContentData?.suspend?.seasonalSuspendText}}</p>
            <p class="text-color">{{authoringContentData?.suspend?.ssqOrElstText}}</p>
          </div>
          <div class="service-note" *ngIf="reason.code === elstConstant">
            <p class="text-color">{{authoringContentData?.manageLine?.serviceNoteFirst}}</p>
            <p class="text-color">{{authoringContentData?.suspend?.ssqOrElstText}}</p>
          </div>
          <div class="service-note" *ngIf="reason.code == edusConstant">
            <p class="text-color">{{authoringContentData?.manageLine?.edusServiceNoteFirst}}</p>
            <p class="text-color">{{authoringContentData?.manageLine?.edusServiceNoteSecond}}</p>
          </div>
          <div class="service-note" *ngIf="reason.code == imsConstant">
            <p class="text-color">{{authoringContentData?.manageLine?.imsServiceNoteFirst}}</p>
            <p class="text-color">{{authoringContentData?.manageLine?.imsServiceNoteSecond}}</p>
          </div>
          <div class="service-note" *ngIf="reason.code == mimsConstant">
            <p class="text-color">{{authoringContentData?.manageLine?.mimsServiceNoteFirst}}</p>
            <p class="text-color">{{authoringContentData?.manageLine?.mimsServiceNoteSecond}}</p>
          </div>
          <div class="service-note" *ngIf="reason.code == rssConstant || reason.code == rsqConstant">
            <p class="text-color">{{authoringContentData?.manageLine?.serviceNoteFirst}}</p>
            <p class="text-color">{{authoringContentData?.manageLine?.serviceNoteSecond}}</p>
          </div>
          <div class="service-note" *ngIf="reason.code == suncConstant">
            <p class="text-color">{{authoringContentData?.manageLine?.suncServiceNoteFirst}}</p>
            <p class="text-color">{{authoringContentData?.manageLine?.suncServiceNoteSecond}}</p>
          </div>
          <div class="service-note" *ngIf="reason.code == retnConstant">
            <p class="text-color">{{authoringContentData?.manageLine?.twoHrsToDisconnectNote}}</p>
            <p class="text-color">{{authoringContentData?.manageLine?.retnServiceNoteSecond}}</p>
          </div>        
          <br>
        </div>
        <div class="col-12" *ngIf="!isSingleFlow">
          <a href="javascript:void(0);" (click)="downloadSuspendValidatedData()" id="download-suspend-file"
            class="small-pink"><i class="fa fa-download" aria-hidden="true"></i> Download spreadsheet for changes made
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
